import { CompanyContractTypeEnum, ICompany } from 'types/Company';
import {
  maskCep,
  maskCNPJ,
  maskCurrencyFormat,
  maskPhone,
  maskResidentialPhone,
} from 'util/masks';

import { Box, Divider, Grid, Stack, Typography } from '@mui/material';

type ICompanyData = {
  company: ICompany | undefined;
};

type IItemCompany = {
  title: string;
};

const ItemCompany: React.FC<IItemCompany> = ({ title, children }) => {
  return (
    <Grid item xs={12} md={3} sm={6} mb={2}>
      <Typography color="GrayText">{title}</Typography>
      <Stack direction="row" spacing={1} mt={1}>
        <Typography color="InfoText" sx={{ wordBreak: 'break-all' }}>
          {children ? children : '-'}
        </Typography>
      </Stack>
    </Grid>
  );
};

export const CompanyData: React.FC<ICompanyData> = ({ company }) => {
  if (!company) {
    return null;
  }
  return (
    <Box p={2}>
      <Grid container alignItems="flex-start" spacing={3}>
        <Grid item container xs={12} md={12} justifyContent="space-between">
          <Typography fontWeight={700} fontSize={18}>
            DADOS DA EMPRESA
          </Typography>
          <Grid container item mt={2}>
            <Typography
              letterSpacing={1.35}
              fontWeight={500}
              fontSize={16}
              paddingRight={0.5}
            >
              TIPO DE CONTRATAÇÃO:
            </Typography>

            <Typography color="black" fontWeight={400}>
              {company.contractType &&
                CompanyContractTypeEnum[
                  company.contractType as unknown as keyof typeof CompanyContractTypeEnum
                ]}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Divider sx={{ mt: 2, mb: 2 }} />

      <Grid container spacing={2} p={2}>
        <ItemCompany title="Razão Social">{company.socialReason}</ItemCompany>
        <ItemCompany title="CNPJ">{maskCNPJ(company.cnpj)}</ItemCompany>
        <ItemCompany title="Telefone Fixo">
          {maskResidentialPhone(company.phone)}
        </ItemCompany>
        <ItemCompany title="Telefone Celular">
          {maskPhone(company.mobilePhone)}
        </ItemCompany>
        <ItemCompany title="Valor do Plano">
          {maskCurrencyFormat(company.planPrice)}
        </ItemCompany>
        <ItemCompany title="CEP">{maskCep(company.address?.cep)}</ItemCompany>
        <ItemCompany title="Logradouro">{company.address?.street}</ItemCompany>
        <ItemCompany title="Número">{company.address?.number}</ItemCompany>
        <ItemCompany title="Bairro">
          {company.address?.neighborhood}
        </ItemCompany>
        <ItemCompany title="Complemento">
          {company.address?.complement}
        </ItemCompany>
        <ItemCompany title="Tipo">
          <Typography
            letterSpacing={1.35}
            fontWeight={500}
            fontSize={16}
            paddingRight={0.5}
          >
            TIPO DE CONTRATAÇÃO:
          </Typography>

          <Typography color="black" fontWeight={400}>
            {company.contractType &&
              CompanyContractTypeEnum[
                company.contractType as unknown as keyof typeof CompanyContractTypeEnum
              ]}
          </Typography>
        </ItemCompany>
        <ItemCompany title="Cidade">{company.address?.city}</ItemCompany>
        <ItemCompany title="Estado">{company.address?.state}</ItemCompany>
     
         
         
      </Grid>
    </Box>
  );
};
